export let PermissionType;
(function (PermissionType) {
  PermissionType["ALL"] = "ALL";
  PermissionType["USER"] = "USER";
  PermissionType["USERS_AND_TEAMS"] = "USERS_AND_TEAMS";
  PermissionType["TEAM"] = "TEAM";
  PermissionType["NONE"] = "NONE";
})(PermissionType || (PermissionType = {}));